// Store URL configuration for different locales
const storeConfig = {
  iOS: {
    en: "https://apps.apple.com/se/app/notely-ai/id6740462619?l=en-GB&platform=iphone",
    es: "https://apps.apple.com/es/app/notely-ai/id6740462619?l=es-ES&platform=iphone",
    fr: "https://apps.apple.com/fr/app/notely-ai/id6740462619?l=fr-FR&platform=iphone",
    de: "https://apps.apple.com/de/app/notely-ai/id6740462619?l=de-DE&platform=iphone",
    pt: "https://apps.apple.com/pt/app/notely-ai/id6740462619?l=pt-PT&platform=iphone",
    vi: "https://apps.apple.com/vn/app/notely-ai/id6740462619?l=vi&platform=iphone",
    sv: "https://apps.apple.com/se/app/notely-ai/id6740462619?l=sv&platform=iphone",
    ro: "https://apps.apple.com/ro/app/notely-ai/id6740462619?l=ro&platform=iphone",
  },
  Android: {
    en: "https://play.google.com/store/apps/details?id=com.cstate.notelyapp&hl=en",
    es: "https://play.google.com/store/apps/details?id=com.cstate.notelyapp&hl=es",
    fr: "https://play.google.com/store/apps/details?id=com.cstate.notelyapp&hl=fr",
    de: "https://play.google.com/store/apps/details?id=com.cstate.notelyapp&hl=de",
    pt: "https://play.google.com/store/apps/details?id=com.cstate.notelyapp&hl=pt",
    vi: "https://play.google.com/store/apps/details?id=com.cstate.notelyapp&hl=vi",
    sv: "https://play.google.com/store/apps/details?id=com.cstate.notelyapp&hl=sv",
    ro: "https://play.google.com/store/apps/details?id=com.cstate.notelyapp&hl=ro",
  },
  macOS: {
    en: "https://apps.apple.com/se/app/notely-ai/id6740462619?l=en-GB&platform=mac",
    es: "https://apps.apple.com/es/app/notely-ai/id6740462619?l=es-ES&platform=mac",
    fr: "https://apps.apple.com/fr/app/notely-ai/id6740462619?l=fr-FR&platform=mac",
    de: "https://apps.apple.com/de/app/notely-ai/id6740462619?l=de-DE&platform=mac",
    pt: "https://apps.apple.com/pt/app/notely-ai/id6740462619?l=pt-PT&platform=mac",
    vi: "https://apps.apple.com/vn/app/notely-ai/id6740462619?l=vi&platform=mac",
    sv: "https://apps.apple.com/se/app/notely-ai/id6740462619?l=sv&platform=mac",
    ro: "https://apps.apple.com/ro/app/notely-ai/id6740462619?l=ro&platform=mac",
  }
};

export const getStoreUrl = (language: string): string => {
  const isAndroid = /Android/.test(navigator.userAgent);
  const platform = isAndroid ? 'Android' : 'iOS';

  // Fallback to English if language is not supported
  const supportedLanguage = language in storeConfig[platform] ? language : 'en';

  return storeConfig[platform][supportedLanguage as keyof typeof storeConfig.iOS];
};

export const getIOSUrl = (language: string): string => {
  const supportedLanguage = language in storeConfig.iOS ? language : 'en';
  return storeConfig.iOS[supportedLanguage as keyof typeof storeConfig.iOS];
};

export const getAndroidUrl = (language: string): string => {
  const supportedLanguage = language in storeConfig.Android ? language : 'en';
  return storeConfig.Android[supportedLanguage as keyof typeof storeConfig.Android];
};

export const getMacUrl = (language: string): string => {
  const supportedLanguage = language in storeConfig.macOS ? language : 'en';
  return storeConfig.macOS[supportedLanguage as keyof typeof storeConfig.macOS];
};